import { useEffect, useState } from 'react'
import api from '@/services/api'

export interface AgencyDirectoryOption {
  _id: string
  firstName?: string
  lastName?: string
  email?: string
  [key: string]: any
}

export const getDirectoryOptionLabel = (
  option: AgencyDirectoryOption
): string => {
  const name = `${option.firstName || ''} ${option.lastName || ''}`.trim()
  return name || option.email || ''
}

/**
 * Fetches the agency's patient and provider lists for use in filter dropdowns.
 */
export const useAgencyDirectory = () => {
  const [patients, setPatients] = useState<AgencyDirectoryOption[]>([])
  const [providers, setProviders] = useState<AgencyDirectoryOption[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchDirectory = async () => {
      setLoading(true)
      try {
        const [patientsRes, providersRes] = await Promise.all([
          api.get('/agency-patient/patients?limit=200'),
          api.get('/agency-provider/therapists?limit=200'),
        ])
        const patientsData = patientsRes.data?.data || patientsRes.data || []
        const providersData =
          providersRes.data?.data || providersRes.data || []
        setPatients(Array.isArray(patientsData) ? patientsData : [])
        setProviders(Array.isArray(providersData) ? providersData : [])
      } catch (err) {
        console.error('Error fetching agency directory:', err)
      } finally {
        setLoading(false)
      }
    }
    fetchDirectory()
  }, [])

  return { patients, providers, loading }
}
